import { FirestoreRepository } from '@upadelmatch/core'
import { UserSchema, type UserDoc } from '@/core/models/user'

// `users/{uid}` — the player's own account document (docs/data-model.md).
// Owned by the perfil feature (the profile is its domain); auth/onboarding
// imports it to create the doc on first run. Owner-only rules: a player
// reads/writes only their own doc.
class UserRepository extends FirestoreRepository<typeof UserSchema> {
  constructor() {
    super('users', UserSchema)
  }

  getMine(uid: string): Promise<UserDoc | null> {
    return this.getById(uid)
  }

  /** Merge-write (creates on first onboarding save; `createdAt` only then). */
  saveMine(uid: string, payload: Record<string, unknown>, opts: { isNew?: boolean } = {}): Promise<void> {
    return this.set(uid, { uid, ...payload }, { setCreatedAt: opts.isNew === true })
  }
}

export const userRepository = new UserRepository()
